import { replyOf } from './brandPageReply';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.jawabai.cloud';
const SESSION_KEY = 'jawabai_chat_session';

function randomSessionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = randomSessionId();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export async function sendChatMessage(content) {
  const res = await fetch(`${API_URL}/api/v1/public/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ content, sessionId: getSessionId() }),
  });

  if (res.status === 429) {
    const err = new Error('rate_limited');
    err.code = 'rate_limited';
    throw err;
  }
  if (!res.ok) {
    throw new Error(`chat_failed_${res.status}`);
  }

  // → { content, suggestions }: the reply and its suggested-question buttons
  // (docs/suggested-questions-design.md §10.1), read like the branded page's.
  return replyOf(await res.json());
}
